import script from "./AddTransaction.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTransaction.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__